<template>
  <div class="static">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'数据统计'},{name:'户数报表'}]"></breadcrumb>
    <div class="static-wrap">
      <div class="static-contain">
        <data-top-nav>
          <el-button v-if="tasklimit"
                     @click="confluenceVisible=true"
                     type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']" />
            <span style="margin-left:5px; font-size:14px;">总汇操作</span>
          </el-button>
        </data-top-nav>
        <div class="static-search_wrap">
          <el-select v-model="channel"
                     @change="channelChange"
                     placeholder="请选择">
            <el-option v-for="item in channelList"
                       :key="item.code"
                       :label="item.desc"
                       :value="item.code"></el-option>
          </el-select>
          <el-select v-model="limit"
                     @change="limitChange"
                     placeholder="请选择">
            <el-option v-for="item in limiList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <el-select v-if="limit!==54&&limit!=55"
                     v-model="weidu"
                     @change="weiduChange"
                     placeholder="请选择">
            <el-option v-for="item in weiduList"
                       :key="item.code"
                       :label="item.desc"
                       :value="item.code"></el-option>
          </el-select>
          <el-select v-if="limit===54"
                     v-model="classTotal"
                     placeholder="请选择">
            <el-option value="展示数据"></el-option>
            <el-option value="展示占比"></el-option>
          </el-select>
          <el-select clearable
                     v-if="limit===36||limit===37"
                     v-model="yearProgress"
                     @change="yearProgressChange"
                     placeholder="请选择">
            <el-option value="展示进度"></el-option>
            <el-option value="展示详情"></el-option>
          </el-select>
          <div v-if="limit===55">
            <span>时间范围：</span>
            <el-select clearable
                       style="width:103px"
                       v-model="timeRange"
                       @change="timeRangeChange">
              <el-option value="今日"></el-option>
              <el-option value="本月"></el-option>
              <el-option value="本年"></el-option>
              <el-option value="自定义"></el-option>
            </el-select>
            <el-date-picker v-model="timeRangeNum"
                            type="daterange"
                            @change="timeRangeNumChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div v-if="limit===55">
            <span>查找种类：</span>
            <el-select clearable
                       style="width:103px"
                       placeholder="不限"
                       v-model="searchType"
                       @change="searchTypeChange">
              <el-option label="变化"
                         value="1"></el-option>
              <el-option label="增加"
                         value="2"></el-option>
              <el-option label="减少"
                         value="3"></el-option>
              <el-option label="不变"
                         value="4"></el-option>
            </el-select>
          </div>
          <div v-if="limit===55">
            <span>省份：</span>
            <el-select clearable
                       style="width:103px"
                       placeholder="所有"
                       v-model="provid"
                       @change="providChange">
              <el-option v-for="item in providList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </div>
          <div v-if="limit===55">
            <span>类别：</span>
            <el-select clearable
                       @change="typeChange"
                       v-model="type"
                       placeholder="所有">
              <el-option v-for="(item,index) in typeList"
                         :key="item.id"
                         :label="item.name"
                         :value="index"></el-option>
            </el-select>
          </div>
          <div v-if="((limit===36||limit === 37) && yearProgress==='展示详情')||limit===54"
               class="static-select_month">
            <el-date-picker @change="monthChange"
                            v-model="month"
                            type="month"
                            placeholder="选择年月"></el-date-picker>
          </div>
          <div v-else-if="limit!==55"
               class="static-button_wrap">
            <el-date-picker @change="yearChange"
                            v-model="year"
                            type="year"
                            placeholder="选择年"></el-date-picker>
          </div>
        </div>
        <div class="static-contant_wrap">
          <div v-if="limit!==32"
               class="static-table-wrap">
            <div class="static-table_title">
              <span v-if="limit===55">{{startTime + ' 至 ' + endTime + ' 共 '}}
                <span style="color:#f0722b">{{totalClientNum}}</span>
                {{' 个单位' + channelName + '变化 '}}
                <span style="color:#f0722b">{{totalSum}}</span>
                户</span>
              <span v-else-if="year">{{tableTitle}}</span>
              <div class="static-table_title_right">
                <a @click=" $refs['file'].click()"
                   v-if="limit===33"
                   class="static-table_download">
                  <input class="static-table-file_input"
                         type="file"
                         style="display:none"
                         @change="importExcel"
                         ref="file">
                  <font-awesome-icon style="color:#F0722B;margin-right:5px"
                                     :icon="['fas', 'level-down-alt']" />导入Excel
                </a>
                <a class="static-table_download"
                   @click="exportExcel()">
                  <font-awesome-icon style="color:#39B54A;margin-right:5px"
                                     :icon="['fas', 'level-up-alt']" />导出Excel
                </a>
              </div>
            </div>
            <div class="static-table">
              <table v-if="limit === 55">
                <tr>
                  <th>单位名称</th>
                  <th>省份</th>
                  <th>地市</th>
                  <th>类别</th>
                  <th>级别</th>
                  <th>初期户数</th>
                  <th>末期户数</th>
                  <th>变化户数</th>
                  <th style="max-width:500px">说明</th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="index">
                  <td>
                    <a @click="gotoDetail(item.cid)">{{item.unitsname}}</a>
                  </td>
                  <td>{{item.provName}}</td>
                  <td>{{item.cityName}}</td>
                  <td>{{item.typeName}}</td>
                  <td>{{item.levelName}}</td>
                  <td>{{item.beforeNum}}</td>
                  <td>{{item.afterNum}}</td>
                  <td>{{item.changeNum}}</td>
                  <td style="max-width:500px">{{item.desc}}</td>
                </tr>
              </table>
              <table v-else-if="limit === 54">
                <tr>
                  <th>序号</th>
                  <th>省份</th>
                  <th>
                    <a @click="showClassChart('c1','行政网')">行政网</a>
                  </th>
                  <th>
                    <a @click="showClassChart('c2','企业网')">企业网</a>
                  </th>
                  <th>
                    <a @click="showClassChart('c3','大小院区')">大小院区</a>
                  </th>
                  <th>
                    <a @click="showClassChart('c4','宾馆酒店')">宾馆酒店</a>
                  </th>
                  <th>
                    <a @click="showClassChart('c5','高档公寓')">高档公寓</a>
                  </th>
                  <th>
                    <a @click="showClassChart('c7','数字媒体运营')">数字媒体运营</a>
                  </th>
                  <th v-if="classTotal==='展示数据'">
                    <a @click="showClassChart('totalNum','合计')">合计</a>
                  </th>
                  <th v-if="classTotal==='展示数据'">
                    <a @click="showClassChart('familyTvNum','电视家庭户')">电视家庭户</a>
                  </th>
                  <th v-if="classTotal==='展示数据'">
                    <a @click="showClassChart('coverRate','有线网户')">覆盖率</a>
                  </th>
                  <th v-if="classTotal==='展示数据'">
                    <a @click="showClassChart('wiredNetNum','有线网户')">有线网户</a>
                  </th>
                  <th v-if="classTotal==='展示数据'">
                    <a @click="showClassChart('permeability','渗透率')">渗透率</a>
                  </th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    <a @click="showClassPie(index)">{{item.areaName}}</a>
                  </td>
                  <td v-for="c of 5"
                      :key="c">
                    <span v-if="classTotal==='展示数据'">{{item[`c${c}`]}}</span>
                    <span v-else>{{item[`c${c}Percent`]}}%</span>
                  </td>
                  <td>
                    <span v-if="classTotal==='展示数据'">{{item.c7}}</span>
                    <span v-else>{{item.c7Percent}}%</span>
                  </td>
                  <td v-if="classTotal==='展示数据'">{{item.totalNum}}</td>

                  <td v-if="classTotal==='展示数据'">{{item.familyTvNum}}</td>
                  <td v-if="classTotal==='展示数据'">{{item.coverRate}}%</td>
                  <td v-if="classTotal==='展示数据'">{{item.wiredNetNum}}</td>
                  <td v-if="classTotal==='展示数据'">{{item.permeability}}%</td>
                </tr>
              </table>
              <table v-else-if="limit===36 && yearProgress==='展示详情'">
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>年基数</th>
                  <th>年任务</th>
                  <th>
                    <span v-if="month">{{month.getMonth()+1}}</span>月总计
                  </th>
                  <th>年增量</th>
                  <th>进度%</th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    <span v-if="weidu===2">{{item.areaName}}</span>
                    <span v-else-if="weidu===3">{{item.userName}}</span>
                    <span v-else>{{item.representOfficeName}}</span>
                  </td>
                  <td>{{item.baseNo}}</td>
                  <td>{{item.yearTask}}</td>
                  <td>{{item.summary}}</td>
                  <td>{{item.yearIncrease}}</td>
                  <td>{{item.progress}}</td>
                </tr>
              </table>
              <table v-else-if="limit===37 && yearProgress==='展示详情'">
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th>上月户数</th>
                  <th>本月户数</th>
                  <th>本月任务
                  </th>
                  <th>月增量</th>
                  <th>进度</th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="index">
                  <td>{{index+1}}</td>
                  <td>
                    {{item.name}}
                  </td>
                  <td>{{item.lastNum}}</td>
                  <td>{{item.thisNum}}</td>
                  <td>{{item.mnTask}}</td>
                  <td>{{item.increaseNum}}</td>
                  <td>{{item.mnPerc}}</td>
                </tr>
              </table>
              <table v-else>
                <tr>
                  <th>序号</th>
                  <th>{{weiduName}}</th>
                  <th v-if="limit === 33 || limit === 34">基数</th>
                  <th v-if="limit ===33">年任务</th>
                  <th v-for="m of 12"
                      :key="m">
                    <a @click="showMonthChart(m)">{{m}}月</a>
                  </th>
                </tr>
                <tr v-for="(item,index) in list"
                    :key="item.id">
                  <td>{{index +1}}</td>
                  <td>
                    <a v-if="weidu===2"
                       @click="showCityChart(index)">{{item.areaName}}</a>
                    <a v-else-if="weidu===3"
                       @click="showCityChart(index)">{{item.userName}}</a>
                    <a v-else
                       @click="showCityChart(index)">{{item.representOfficeName}}</a>
                  </td>
                  <td v-if="limit === 33 || limit === 34">{{item.baseNo}}</td>
                  <td v-if="limit ===33">{{item.yearTask}}</td>
                  <td v-for="m of 12"
                      :key="m"
                      style="width:80px">
                    {{item[`m${m}`]}}
                    <span v-if="limit===36||limit===37">%</span>
                  </td>
                </tr>
              </table>
            </div>
            <el-pagination v-if="limit === 55"
                           @current-change="changePage"
                           :current-page="page"
                           class="static-pagination"
                           background
                           layout="prev, pager, next"
                           :total="pageSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="static-chart"
               :title="chartTitle"
               :visible.sync="optionVisible"
               :width="width+20+'px'">
      <v-chart theme="dark"
               v-if="optionVisible"
               :style="{width:width+'px'}"
               :options="option"
               style="height:500px"></v-chart>
    </el-dialog>
    <el-dialog class="static-confluence"
               title="总汇操作"
               width="450px"
               :close-on-click-modal="false"
               :visible.sync="confluenceVisible">
      <el-form label-position="top"
               class="static-confluence-form">
        <el-row :gutter="1">
          <el-col :span="14">
            <el-form-item label="时间">
              <el-date-picker v-model="confluenceForm.year"
                              type="month"
                              placeholder="选择月">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="频道">
              <el-select v-model="confluenceForm.channel"
                         placeholder="请选择">
                <el-option v-for="item in channelList"
                           :key="item.code"
                           :label="item.desc"
                           :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   @click="confluence()">重新分配</el-button>
        <el-button @click="confluenceVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import dataTopNav from '@/components/dataTopNav'
import ECharts from 'vue-echarts'
import 'echarts'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: {
    breadcrumb,
    dataTopNav,
    'v-chart': ECharts
  },
  created() {
    Promise.all([
      this.getLimitList(),
      this.getWeiduList(),
      this.getChannelList()
    ])
      .then(async () => {
        console.log(this.$route.query)
        if (!Object.keys(this.$route.query).length) {
          this.limitChange()
        } else {
          await this.getSearchList()
          this.limit = 55
          this.channel = Number(this.$route.query.channel)
          this.timeRange = this.$route.query.timeRange
          this.endTime = this.$route.query.endTime
          this.page = Number(this.$route.query.page)
          this.provid = this.$route.query.provid
            ? Number(this.$route.query.provid)
            : ''
          this.searchType = this.$route.query.searchType
            ? this.$route.query.searchType
            : ''
          this.startTime = this.$route.query.startTime
          if (this.timeRange === '自定义') {
            this.timeRangeNum.push(this.startTime)
            this.timeRangeNum.push(this.endTime)
          }
          this.type = this.$route.query.type
            ? Number(this.$route.query.type)
            : ''
          this.getClientChange()
        }
      })
      .catch(error => {
        console.log(error)
        this.$message.error('网络错误，稍后重试')
      })
  },
  computed: {
    xlist() {
      let list = _.cloneDeep(this.list)
      if (
        (this.weidu === 2 && list[this.list.length - 1].areaName === '总计') ||
        (weidu === 3 && list[this.list.length - 1].userName === '总计') ||
        (this.weidu === 1 &&
          list[this.list.length - 1].representOfficeName === '总计')
      ) {
        list.pop()
      }
      return list
    }
  },
  data() {
    return {
      totalClientNum: '',
      totalSum: '',

      width: '',
      channel: '',
      channelName: '',
      limit: '',
      limitName: '',
      weidu: '',
      weiduName: '',
      yearProgress: '展示详情',
      classTotal: '展示数据',
      year: '',
      month: '',
      timeRange: '今日',
      timeRangeNum: [],
      startTime: '',
      endTime: '',
      searchType: '',
      provid: '',
      type: '',
      page: 1,

      optionVisible: false,
      limiList: [],
      channelList: [],
      weiduList: [],
      providList: [],
      typeList: [],
      list: [],
      option: {},
      chartTitle: '',
      tableTitle: '',

      pageSize: 0,

      tasklimit: false,
      confluenceVisible: false,
      confluenceForm: {
        year: '',
        month: '',
        channel: ''
      }
    }
  },
  methods: {
    //初始化
    initDate() {
      this.year = new Date()
      this.month = new Date()
    },
    allList() {
      this.list = []
      switch (this.limit) {
        case 33:
          this.limitName = '任务分配'
          this.getYearTaskList()
          break
        case 34:
          this.limitName = '每月总汇'
          this.getSummaryList()
          break
        case 35:
          this.limitName = '每月增长'
          this.getIncreaseList()
          break
        case 36:
          this.yearProgress = '展示进度'
          this.limitName = '全年进度'
          this.getYearProgressList()
          break
        case 37:
          this.yearProgress = '展示进度'
          this.limitName = '当月任务'
          this.getMonthProgressList()
          break
        case 54:
          this.limitName = '分类统计'
          this.getClientStatisClassList()
          break
        case 55:
          this.getSearchList()
          this.startTime = moment().format('YYYY-MM-DD')
          this.endTime = this.startTime
          this.limitName = '收视变化'
          ;(this.timeRange = '今日'),
            (this.timeRangeNum = ''),
            this.getClientChange()
          break
      }
    },

    //获取分类统计下拉列表
    getSearchList() {
      //获取省份列表
      return Promise.all([
        axios.post(api.areaList).then(res => {
          if (res.data.code === 0) {
            console.log('获取省-市-区列表成功', res.data.result)
            this.providList = res.data.result
          } else {
            console.log('获取省-市-区列表失败', res.data.msg)
          }
        }),
        //获取类别列表
        axios.get(api.clientCategory).then(res => {
          if (res.data.code === 0) {
            console.log('获取类型--级别列表成功', res.data.result)
            this.typeList = res.data.result
          } else {
            console.log('获取类型--级别列表失败', res.data.msg)
          }
        })
      ]).catch(error => {
        this.$message.error('网络错误，稍后重试')
      })
    },
    //获取户数列表下的权限
    getLimitList() {
      let menuList = _.cloneDeep(this.$store.state.menuList)
      for (let item1 of menuList) {
        if (item1.id === 50) {
          let list = item1.children
          for (let item2 of list) {
            if (item2.id === 30) {
              this.limiList = item2.children
              this.limit = this.limiList[0].id
              this.limitName = this.limiList[0].name
              for (let item3 in this.limiList) {
                if (this.limiList[item3].id === 38) {
                  this.tasklimit = true
                  this.limiList.splice(item3, 1)
                }
              }
            }
          }
        }
      }
    },
    getChannelList() {
      return axios.get(api.getChannelTypeList).then(res => {
        if (res.data.code === 0) {
          console.log('获取台类型成功', res.data.result)
          this.channelList = res.data.result
          this.channel = this.channelList[0].code
          this.channelName = this.channelList[0].desc
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getWeiduList() {
      return axios.get(api.getWeiduList).then(res => {
        if (res.data.code === 0) {
          console.log('获取维度类型成功', res.data.result)
          this.weiduList = res.data.result
          this.weidu = this.weiduList[1].code
          this.weiduName = this.weiduList[1].desc
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    //频道改变
    channelChange(channelCode) {
      switch (channelCode) {
        case 0:
          this.channelName = '中文台'
          break
        case 1:
          this.channelName = '资讯台'
          break
      }
      this.limitChange()
    },
    //获取的列表改变
    limitChange() {
      if (this.limit !== 55) {
        this.$router.replace({ path: '/data/static', query: {} })
      }
      this.initDate()
      this.allList()
    },
    //维度改变
    weiduChange() {
      switch (this.weidu) {
        case 3:
          this.weiduName = '个人'
          break
        case 2:
          this.weiduName = '省份'
          break
        case 1:
          this.weiduName = '代表处'
          break
      }
      this.allList()
    },
    //年选择框改变
    yearChange(v) {
      this.allList()
    },
    //全年进度查看详情或者进度select改变
    yearProgressChange(v) {
      this.initDate()
      if (this.limit === 36) {
        if (v === '展示详情') {
          this.getYearMonthProgressList()
        } else {
          this.getYearProgressList()
        }
      } else {
        if (v === '展示详情') {
          this.getMonthMonthProgressList()
        } else {
          this.getMonthProgressList()
        }
      }
    },
    //月选择框改变
    monthChange(v) {
      switch (this.limit) {
        case 36:
          this.getYearMonthProgressList()
          break
        case 37:
          this.getMonthMonthProgressList()
          break
        case 54:
          this.getClientStatisClassList()
          break
      }
    },
    //时间范围改变
    timeRangeChange() {
      this.timeRangeNum = null
      if (this.timeRange !== '自定义') {
        let day = moment()
        if (this.timeRange === '今日') {
          this.startTime = day.format('YYYY-MM-DD')
          this.endTime = this.startTime
        } else if (this.timeRange === '本月') {
          this.startTime = day.years() + '-' + (day.months() + 1) + '-01'
          this.endTime = moment(this.startTime, 'YYYY-MM-DD')
            .add(day.daysInMonth() - 1, 'days')
            .format('YYYY-MM-DD')
        } else {
          this.startTime = day.years() + '-01-01'
          this.endTime = day.years() + '-12-31'
        }
        this.getClientChange()
      }
    },
    //时间段日期选择框改变
    timeRangeNumChange() {
      this.timeRange = '自定义'
      if (this.timeRangeNum) {
        this.startTime = this.timeRangeNum[0]
        this.endTime = this.timeRangeNum[1]
        this.page = 1
        this.getClientChange()
      }
    },
    //查找种类变化
    searchTypeChange() {
      this.page = 1
      this.getClientChange()
    },
    //查找省份改变
    providChange() {
      this.page = 1
      this.getClientChange()
    },
    //类别改变
    typeChange() {
      this.page = 1
      this.getClientChange()
    },

    //任务分配列表
    getYearTaskList() {
      this.tableTitle =
        this.year.getFullYear() +
        '年' +
        '户数全年/每月任务分配--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      }
      axios
        .post(api.getYearTaskList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取任务分配列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //显示城市一年的任务分配图
    showCityChart(index) {
      this.width = 700
      let city = this.list[index]
      let weidu
      if (this.weidu === 2) {
        weidu = city.areaName
      } else if (this.weidu === 3) {
        weidu = city.userName
      } else {
        weidu = city.representOfficeName
      }
      this.chartTitle =
        this.year.getFullYear() +
        '年' +
        this.limitName +
        '图 --【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 20
        },
        tooltip: {},
        dataset: {
          source: city
        },
        xAxis: {
          type: 'category',
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ]
        },
        yAxis: {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: 'line',
            data: [
              city.m1,
              city.m2,
              city.m3,
              city.m4,
              city.m5,
              city.m6,
              city.m7,
              city.m8,
              city.m9,
              city.m10,
              city.m11,
              city.m12
            ]
          }
        ]
      }
      this.optionVisible = true
    },
    //显示所有城市某月的任务分配对比图
    showMonthChart(month) {
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20
      this.chartTitle =
        this.year.getFullYear() +
        '年' +
        month +
        '月' +
        this.limitName +
        '对比图 --【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: this.xlist.map(item => {
            if (this.weidu === 2) {
              return item.areaName
            } else if (this.weidu === 3) {
              return item.userName
            } else {
              return item.representOfficeName
            }
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split('').join('\n')
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis:
          this.limit === 36
            ? [
                {
                  name: '百分比(%)'
                }
              ]
            : {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: 'bar',
            data: this.xlist.map(item => {
              return item['m' + month]
            })
          }
        ]
      }
      this.optionVisible = true
    },
    //分类统计柱状图
    showClassChart(type, name) {
      if (this.classTotal === '展示占比') {
        return
      }
      this.width = this.list.length * 20 < 500 ? 500 : this.list.length * 20
      this.chartTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月各城市' +
        name +
        '对比图 --【' +
        this.channelName +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 120
        },
        tooltip: {},
        dataset: {
          source: this.list
        },
        xAxis: {
          type: 'category',
          data: this.xlist.map(item => {
            if (this.weidu === 2) {
              return item.areaName
            } else if (this.weidu === 3) {
              return item.userName
            } else {
              return item.representOfficeName
            }
          }),
          axisLabel: {
            interval: 0,
            formatter: function(value) {
              return value.split('').join('\n')
            },
            textStyle: {
              fontSize: 10 //更改坐标轴文字大小
            }
          }
        },
        yAxis:
          name === '有线网户' || name === '电视家庭户'
            ? [
                {
                  name: '万'
                }
              ]
            : {},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [
          {
            type: 'bar',
            data: this.xlist.map(item => {
              if (name === '有线网户' || name === '电视家庭户') {
                return item[type] * 0.0001
              } else {
                return item[type]
              }
            })
          }
        ]
      }
      this.optionVisible = true
    },
    //分类统计饼状图
    showClassPie(index) {
      this.width = 700
      let city = this.list[index]
      this.chartTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月' +
        city.areaName +
        '分类统计' +
        '占比图--【' +
        this.channelName +
        '】'
      this.option = {
        legend: {},
        grid: {
          x: 50,
          y: 50,
          x2: 30,
          y2: 20
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['行政网', '企业网', '大小院区', '宾馆酒店', '大小公寓']
        },
        dataset: {
          source: city
        },
        series: [
          {
            name: '分类统计',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
              { value: city.c1, name: '行政网' },
              { value: city.c2, name: '企业网' },
              { value: city.c3, name: '大小院区' },
              { value: city.c4, name: '宾馆酒店' },
              { value: city.c5, name: '大小公寓' }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.optionVisible = true
    },
    //每月总汇列表
    getSummaryList() {
      this.tableTitle =
        this.year.getFullYear() +
        '年' +
        '数月统计(单位：万户)--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'

      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      }
      axios
        .post(api.getSummaryList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取每月总汇列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //每月增长列表
    getIncreaseList() {
      this.tableTitle =
        this.year.getFullYear() +
        '年' +
        '每月月户数增量（单位：万户）--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      }
      axios
        .post(api.getIncreaseList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取每月增长列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //全年进度列表
    getYearProgressList() {
      this.tableTitle =
        this.year.getFullYear() +
        '年' +
        '户数年任务进度--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'

      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      }
      axios
        .post(api.getYearProgressList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('全年进度列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //全年进度某月详情列表
    getYearMonthProgressList() {
      this.tableTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月' +
        '户数进度详细（单位：户）--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'
      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      }
      axios
        .post(api.getYearMonthProgressList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('全年任务进度详情成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //当月任务列表
    getMonthProgressList() {
      this.tableTitle =
        this.year.getFullYear() +
        '年' +
        '当月户数任务完成比例--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'

      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.year.getFullYear()
      }
      axios
        .post(api.getMonthProgressList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('当月任务列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //当月任务详情列表
    getMonthMonthProgressList() {
      this.tableTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月' +
        '户数当月任务进度详细（单位：户）--【' +
        this.channelName +
        '】-【' +
        this.weiduName +
        '】'

      let params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      }
      axios
        .post(api.getMonthMonthProgressList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('当月任务详情列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //分类统计列表
    getClientStatisClassList() {
      this.tableTitle =
        this.month.getFullYear() +
        '年' +
        (this.month.getMonth() + 1) +
        '月' +
        '户数分类统计（单位：万户）--【' +
        this.channelName +
        '】'

      let params = {
        channel: this.channel,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      }
      axios
        .post(api.getClientStatisClassList, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('分类统计列表成功', res.data.result)
            this.list = res.data.result
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //收视变化列表
    getClientChange() {
      let params = {
        channel: this.channel,
        endTime: this.endTime,
        page: this.page,
        pageSize: 10,
        provid: this.provid,
        searchType: this.searchType,
        startTime: this.startTime,
        type: this.type
      }
      let query = _.cloneDeep(params)
      query.timeRange = this.timeRange
      this.$router.replace({ path: '/data/static', query: query })
      axios
        .post(api.getClientChange, params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取收视变化列表成功', res.data.result)
            this.list = res.data.result.records
            this.pageSize = res.data.result.total
            this.totalSum = res.data.result.totalSum
            this.totalClientNum = res.data.result.totalClientNum
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    changePage(v) {
      this.page = v
      this.getClientChange()
    },
    //导出excel
    exportExcel() {
      let params = {}
      let url = ''
      switch (this.limit) {
        case 33:
          this.limitName = '任务分配'
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          }
          url = api.getYearTaskListExport
          break
        case 34:
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          }
          url = api.getSummaryListExcel
          break
        case 35:
          url = api.getIncreaseListExcel
          params = {
            channel: this.channel,
            weidu: this.weidu,
            year: this.year.getFullYear()
          }
          break
        case 36:
          if (this.yearProgress === '展示进度') {
            url = api.getYearProgressListExcel
            params = {
              channel: this.channel,
              weidu: this.weidu,
              year: this.year.getFullYear()
            }
          } else {
            url = api.getYearMonthProgressListExcel
            params = {
              channel: this.channel,
              weidu: this.weidu,
              year: this.month.getFullYear(),
              month: this.month.getMonth() + 1
            }
          }
          break
        case 37:
          if (this.yearProgress === '展示进度') {
            params = {
              channel: this.channel,
              weidu: this.weidu,
              year: this.year.getFullYear()
            }
            url = api.getMonthProgressListExcel
          } else{
            params = {
        channel: this.channel,
        weidu: this.weidu,
        year: this.month.getFullYear(),
        month: this.month.getMonth() + 1
      },
      url = api.getMonthMonthProgressListExcel
          }

          break
        case 54:
          params = {
            channel: this.channel,
            year: this.month.getFullYear(),
            month: this.month.getMonth() + 1
          }
          if (this.classTotal === '展示数据') {
            url = api.getClientStatisClassListExcel
          } else {
            url = api.getClientStatisClassListPercExcel
          }
          break
        case 55:
          url = api.getClientChangExcel
          params = {
            channel: this.channel,
            endTime: this.endTime,
            page: this.page,
            pageSize: 10,
            provid: this.provid,
            searchType: this.searchType,
            startTime: this.startTime,
            type: this.type
          }

          break
      }
      axios({
        // 用axios发送post请求
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 表明返回服务器返回的数据类型
      })
        .then(res => {
          let blob = new Blob([res.data], { type: 'application/x-xls' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${
            this.limit === 55 ? '收视变化' : this.tableTitle
          }.xls`
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //导入excel
    importExcel(e) {
      let file = e.target.files[0]
      if (file.length) {
        return
      }
      let param = new FormData()
      param.append('file', file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      axios
        .post(api.importYearTask, param, config)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '上传文件成功',
              type: 'success'
            })
            this.allList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    },
    //总汇操作
    confluence() {
      let params = {
        channel: this.confluenceForm.channel,
        year: this.confluenceForm.year.getFullYear(),
        month: this.confluenceForm.year.getMonth() + 1
      }
      axios
        .post(
          api.summaryTask +
            `?year=${params.year}&month=${params.month}&channel=${
              params.channel
            }`
        )
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '重新分配成功',
              type: 'success'
            })
            this.confluenceVisible = false
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试')
        })
    },
    //去往详情页
    gotoDetail(id) {
      this.$router.push({
        path: `/ch_channel/detail/${id}`,
        query: { from: 'static' }
      })
    }
  }
}
</script>

<style lang="scss">
.static {
  min-width: 1255px;
  .static-wrap {
    padding: 77px 30px 0px 30px;
    .static-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .static-search_wrap {
        display: flex;
        background: #f8f8f8;
        padding: 20px 27px 5px 27px;
        justify-content: flex-start;
        flex-wrap: wrap;
        .el-select {
          width: 108px;
          margin-right: 17px;
          margin-bottom: 15px;
        }
        .el-range-editor {
          margin-right: 17px;
        }
        .static-button_wrap {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 108px;
            height: 40px;
          }
        }
        .static-select_month {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .el-date-editor {
            width: 120px;
            height: 40px;
          }
        }
      }
      .static-contant_wrap {
        padding: 30px;
        .static-table_title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 27px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .static-table_title_right {
            display: flex;

            .static-table_download {
              margin-left: 10px;
              cursor: pointer;
              width: 108px;
              height: 40px;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 40px;
              text-align: center;
            }
          }
        }
        .static-table {
          min-height: 470px;
          tr {
            height: 47px;
            th {
              position: sticky;
              top: 113px;
              height: 40px;
              background: #5d5d5d;
              color: #fff;
              a {
                cursor: pointer;
              }
            }
            td {
              text-align: center;
              height: 54px;
              a {
                cursor: pointer;
                color: #f0722b;
              }
              div {
                display: inline-block;
              }
            }
          }
        }
        .static-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
  .static-chart {
    .el-dialog__body {
      padding-top: 0px;
      padding-bottom: 10px;
      padding-left: 10px;
    }
  }
  .static-confluence {
    .el-dialog__header {
      color: #4a4a4a;
      font-weight: 600;
      font-size: 18px;
    }
    .el-dialog__body {
      padding-top: 6px;
      padding-bottom: 0px;
    }
    .el-dialog__footer {
      padding-top: 0px;
      text-align: left;
      .el-button {
        width: 100px;
      }
    }
  }
}
</style>
